import React, { useRef, useCallback, useMemo, useState, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import { Grid, Box } from '@chakra-ui/react';
import { AutocompleteInput, Button, SelectInput, TextInput, Unform } from 'components';
import { debounce } from 'utils/debounce';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { RouteComponentProps } from 'react-router';
import { modalityOptions } from 'constants/demand';
import { getClientUsers } from 'services/usersTable';
import { getLoggedUser } from 'utils/storage';
import { verificationRolesExists } from '../../../../../constants/allfunctions';
// import { Container } from './styles';

interface IFormData {
  demanda: string;
  criadoPor: number;
  modalidade: number;
}

interface IProps {
  history: RouteComponentProps['history'];
}

const FiltersHeader: React.FC<IProps> = ({ history }) => {
  const formRef = useRef<FormHandles>(null);
  const [users, setUsers] = useState<
    {
      id: number;
      name: string;
    }[]
  >([]);

  const { criadoPor, modalidade, demanda } = useMemo(() => {
    return queryToObj(history.location.search) as {
      criadoPor?: string;
      modalidade?: string;
      demanda?: string;
    };
  }, [history.location.search]);

  const handleSearch = useCallback(
    debounce(() => {
      const formData = formRef.current?.getData() as IFormData;

      const query = objToQuery({ ...formData, page: 0 });

      history.replace(`${routePaths.clientDemands}?${query}`);
    }, 600),
    [],
  );

  useEffect(() => {
    (async () => {
      const client = getLoggedUser().client;
      if (client) {
        const { data } = await getClientUsers(client);
        setUsers(data);
      }
    })();
  }, []);

  return (
    <Unform initialData={{ criadoPor, modalidade, demanda }} formRef={formRef}>
      <Grid mt="1rem" mb="1rem" maxH="40px" templateColumns="repeat(5, 1fr)" gap={6}>
        <TextInput
          name="demanda"
          notErrorMargin
          backgroundColor="#fff"
          leftIcon={{ name: 'search', color: 1100 }}
          placeholder="Buscar..."
          onInput={handleSearch}
        />
        <AutocompleteInput
          name="criadoPor"
          placeholder="Criado por..."
          optionLabel="name"
          optionValue="id"
          onSelectOption={handleSearch}
          options={users}
        />
        <SelectInput
          name="modalidade"
          placeholder="Modalidade"
          optionValue="id"
          optionLabel="name"
          options={modalityOptions}
          onInput={handleSearch}
        />
        <Box />
        {/* {getLoggedUser().isParticipant ? ( */}
        {(verificationRolesExists('ROLE_ADMIN') ||
          verificationRolesExists('ROLE_CONSULTAS_DOCUMENTOS_CONTRATOS')) && (
          <Button type="submit" href="/clientDemands/new">
            Nova solicitação
          </Button>
        )}
        {/* // ) : null} */}
      </Grid>
    </Unform>
  );
};

export default FiltersHeader;
